
    <div class="row headings">
    <div class="col-3 mt-2">
        <!-- <img src="../../assets/sacco.png" width="150"> -->
           <div *ngIf="logoroleId !== 1" fxLayoutAlign="center center">
            <div *ngIf="bankLogo">
              <img [src]="bankLogo ? bankLogo : '/assets/logo1.png'" height="100" width="150"/>
            </div>
          </div>

          <div *ngIf="logoroleId === 1" fxLayoutAlign="center center">
            <img src="../../assets/sacco.png" height="150" />
          </div>
        <!-- </div> -->
        
    </div>
    <div class="col-5 mt-4" style="white-space: normal; word-break: break-word; text-align: center;">

      <p class="mb-0"><b>{{ bankName }}</b></p>
    
      <p class="mt-0 mb-0" style="white-space: normal; word-break: break-word;">
        <b> 
          <ng-container *ngIf="reportFormateType">
            {{ getReportFormatTypeName() }} 
          </ng-container>
          {{ title }} Summary 
          <ng-container *ngIf="transactionDate; else dateCheck">
            on {{ transactionDate | date: 'dd-MM-yyyy' }}
          </ng-container>
          <ng-template #dateCheck>
            <ng-container *ngIf="fromDate && toDate; else singleDate">
              From {{ fromDate | date: 'dd-MM-yyyy' }} to {{ toDate | date: 'dd-MM-yyyy' }}
            </ng-container>
            <ng-template #singleDate>
              <ng-container *ngIf="fromDate">
                on {{ fromDate | date: 'dd-MM-yyyy' }}
              </ng-container>
              <ng-container *ngIf="!fromDate && toDate">
                on {{ toDate | date: 'dd-MM-yyyy' }}
              </ng-container>
              <ng-container *ngIf="monthYear">
                on {{ monthYear | date: 'MMM-yyyy' }}
              </ng-container>
            </ng-template>
          </ng-template>
        </b>
      </p>
    
    </div>
    <div class="col-4  mt-3" style="line-height: 21px;font-size: 14px !important;padding-left: 80px !important;">
        <ng-container *ngIf="branchDisplayName">
        <b class="d-flex left-align">Branch : {{branchDisplayName}}</b>
    </ng-container>

        <ng-container *ngIf="createdByDisplayName">
            <b class="d-flex left-align">
              Created By : {{ createdByDisplayName }}
            </b>
          </ng-container>

<b class="d-flex left-align">Generation Date : {{today | date: 'dd-MM-yyyy HH:mm:ss'}}</b>
<p class="d-flex left-align"><b>Generated By : {{loggedInUserName}}</b> </p>

           

    </div>
</div>